import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M11 7L12.4293 5.57071C12.4683 5.53166 12.5317 5.53166 12.5707 5.57071L14.4293 7.42929C14.4683 7.46834 14.4683 7.53166 14.4293 7.57071L13 9M11 7L6.52929 11.4707C6.51054 11.4895 6.5 11.5149 6.5 11.5414V13.4C6.5 13.4552 6.54477 13.5 6.6 13.5H8.45858C8.4851 13.5 8.51054 13.4895 8.52929 13.4707L13 9M11 7L13 9"
            stroke="currentColor"
            strokeLinecap="round"
        />
        <path
            d="M5 13.5H4C3.17157 13.5 2.5 12.8284 2.5 12V4C2.5 3.17157 3.17157 2.5 4 2.5H12C12.8284 2.5 13.5 3.17157 13.5 4V4"
            stroke="currentColor"
        />
        <line
            stroke="currentColor"
            strokeLinecap="round"
            x1="5.5"
            x2="5.5"
            y1="3.5"
            y2="1.5"
        />
        <line
            stroke="currentColor"
            strokeLinecap="round"
            x1="10.5"
            x2="10.5"
            y1="3.5"
            y2="1.5"
        />
    </svg>
);

export default Icon;
